module.exports = __webpack_public_path__ + "static/media/29EUNOG13.fe3d703d.jpg";